export function formatMapsForFront(data) {
  const mapArray = []
  if (!data) {
    return mapArray
  }
  data.forEach((map) => {
    mapArray.push(countGeolocPoints(map))
  })
  return mapArray
}

export function formatMapInfoForFront(data) {
  const theMap = data[0]
  console.log(theMap)

  let markers = theMap.geolocationPoints.map(obj => {
    return {title: obj.name, position: {lng: Number(obj.lng), lat: Number(obj.lat)}}
  })

  return {
    'description': theMap.description,
    'name': theMap.name,
    'mapId': theMap.mapId,
    'tenantId': theMap.tenantId,
    geolocationPoints: markers
  }
}

function countGeolocPoints(data) {
  return {
    mapId: data.mapId,
    name: data.name,
    imageUrl: data.imageUrl,
    description: data.description,
    geoLocationsCount: data.geolocationPoints ? data.geolocationPoints.length : 0
  }
}

export default {
  formatMapsForFront,
  formatMapInfoForFront
}
